import { State } from 'common/store/reducers';

export const selectInviteLoading = (state: State) => state.teamInvite.invite.loading;

export const selectInviteExist = (state: State) => state.teamInvite.invite.exist;

export const selectInviteError = (state: State) => state.teamInvite.invite.error;

export const selectInviteConnections = (state: State) => state.teamInvite.invite.connections;

const mapConnectionToMethod = (
  connection: TeamInviteModule.InviteConnection
): TeamInviteModule.InviteOwnershipMethod | null => {
  switch (connection) {
    case 'Username-Password-Authentication':
      return 'password';
    case 'google-oauth2':
      return 'google-oauth2';
    case 'windowslive':
      return 'windowslive';
    default:
      return null;
  }
};

export const selectInviteConnectionMethods = (state: State): TeamInviteModule.InviteOwnershipMethod[] => {
  const methods = selectInviteConnections(state)
    .map(mapConnectionToMethod)
    .filter(Boolean) as TeamInviteModule.InviteOwnershipMethod[];

  return Array.from(new Set(methods));
};
